import React, {
  useContext,
  useEffect,
  useState
} from 'react';

import { RequestNextApi } from '../../../api/Request';
import { ProgressContext } from '../../../components/Context/progressContext';
import { getCookie } from '../../../utils/cookieHandle';
import { ShowNotification } from '../../../utils/notification/snackbarUtils';
import { showArticleBlock } from '../../../utils/static-pages/function';
import { PAGES_SLUG } from '../../../utils/static-pages/model';

export default function AnnualConference() {
  const [articleBlocks, setArticleBlocks] = useState();
  const { state: progressContext, update: updateProgress } = useContext(ProgressContext);

  useEffect(() => {
    const fetchPage = async () => {
      try {
        const res = await RequestNextApi.post('/pages',
          {
            slug: PAGES_SLUG.ANNUAL_CONF,
            jwtToken: getCookie('jwt-token')
          }
        );
        if (res.data.success) {
          setArticleBlocks(res.data.page.articleBlocks);
        } else {
          ShowNotification.error('Fetch page failed');    
        }
      } catch (error) {
        ShowNotification.error('Fetch page failed');
      }
    };

    const initPage = async () => {
        updateProgress({isLoading: true});
        await fetchPage();
        updateProgress({isLoading: false});
    }

    initPage();
  }, []);

  return (
    <div>
        {articleBlocks && (
            <div className='mt-4 bg-white border px-5 py-6 rounded-xl border-solid border-primary-100 shadow'>
            {articleBlocks.map((item, index) => (
                showArticleBlock(item, index)
            ))}
            </div>
        )}
    </div>
  )
}
